/**
 * Request to add jobs to an existing service order in DMS.
 */
import {DmsRequest} from '../common/dms-request';
import {AddServiceOrderJobsRequestBody} from './add-service-order-jobs-request-body';
import {TechnicalHeaderInRequest} from '../common/technical-header-in-request';
import {FunctionalHeader} from '../common/functional-header';
import {UserInformation} from '../common/user-information';

export class AddServiceOrderJobsRequest implements DmsRequest {
  readonly simpleName = 'add-order-jobs';
  technicalHeader: TechnicalHeaderInRequest;
  functionalHeader: FunctionalHeader;
  userInformation: UserInformation;
  body: AddServiceOrderJobsRequestBody;
}
